import {connect} from 'react-redux'
import {getQueryAutocompleteCompaniesActionCreator} from 'data/redux/actions/guiActions';

import AwesomeDebouncePromise from 'awesome-debounce-promise';
import CompanyAutoCompleteInput
  from 'gui/components/editors/voucherEditor/components/voucherDetailsForm/components/voucherDetails/components/companyAutoCompleteInput';
import {ICompanyPrediction} from 'data/interfaces/products';

const mapStateToProps = (state, {label, field}) => {
  return {label, field};
};


const mapDispatchToProps = (dispatch) => {
  const queryCompany: any = AwesomeDebouncePromise(
    (query): Promise<ICompanyPrediction[]> => dispatch(getQueryAutocompleteCompaniesActionCreator(query)),
    200,
  );


  return {
    queryCompany: (query) => queryCompany(query)
  };
};

const CompanyAutoCompleteInputContainer = connect(mapStateToProps, mapDispatchToProps)(CompanyAutoCompleteInput as any);

export default CompanyAutoCompleteInputContainer;
